<template>
	<div
		class="card amd-sticky cm-filters cm-filters-desktop"
		:class="{ loading: filterLoading }"
	>
		<div class="card-body pb-0">
			<div class="float-end amd-loader loader-mini loader-noicon">
				<div class="loading"></div>
			</div>
			<h3 class="card-title">
				<i
					v-if="this.$store.state.countActiveFilters > 0"
					class="mdi mdi-filter"
				></i>
				<i v-else class="mdi mdi-filter-outline"></i>
				{{ filterInit ? 'Filter' : 'Lade Filter...' }}
			</h3>
		</div>
		<list-filter
			v-if="filterInit"
			:filter-fields="filterFields"
			:filter-loading="filterLoading"
			:count-total="countTotal"
			:ref-data="refData"
			@update-filter="updateFilter"
		/>
		<list-filter-skeleton v-else />
	</div>
</template>

<script>
import store from '@/store'
import ListFilter from '@/components/list/ListFilter'
import ListFilterSkeleton from '@/components/list/ListFilterSkeleton'

export default {
	name: 'ListSidebar',
	components: {
		ListFilter,
		ListFilterSkeleton,
	},
	data() {
		return {
			loading: true,
			makeSelected: false,
		}
	},
	props: {
		filterInit: Boolean,
		filterLoading: Boolean,
		filterFields: Object,
		countTotal: {
			type: Number,
			default: 0,
		},
		refData: Object,
	},
	computed: {
		checkMake() {
			if (store.state.filterItems['make'] === undefined) {
				return false
			} else {
				return true
			}
		},
	},
	methods: {
		updateFilter() {
			this.$emit('updateFilter')
		},
	},
}
</script>

<style lang="scss"></style>
